// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tabs .el-tabs__content[data-v-0916840a] {\n  height: 460px;\n}\n.title[data-v-0916840a]::before {\n  content: '*';\n  color: #F56C6C;\n  margin-right: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
